export const SET_LISTING_PACKAGES = 'lv3/SET_LISTING_PACKAGES';
export const SET_LISTING_PACKAGES_IS_LOADING = 'lv3/SET_LISTING_PACKAGES_IS_LOADING';
export const SET_INITIAL_DATA_LOADED = 'lv3/SET_INITIAL_DATA_LOADED';
export const CLEAR_ALL_PACKAGES = 'lv3/CLEAR_ALL_PACKAGES';
export const SET_PAGE_LOADING = 'lv3/SET_PAGE_LOADING';
